// PaymentFailure.js
import React from 'react';
import { FaTimesCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const PaymentFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-red-100 via-white to-red-200 px-4 pt-2 pb-4 sm:pt-10 sm:px-3 rounded-2xl">

      <FaTimesCircle className="text-6xl sm:text-7xl text-red-500 animate-bounce mb-3" />

      <h1 className="text-3xl sm:text-4xl font-bold text-red-700 text-center mb-2">
        Payment Failed
      </h1>

      <p className="text-base sm:text-lg text-gray-700 text-center max-w-md mb-6">
        Unfortunately, your payment could not be processed. Please try again.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full max-w-sm justify-center items-center">
        
        <button
          onClick={() => window.location.href = '/payment.html'}
          className="w-full sm:w-auto bg-red-600 text-white px-5 py-3 rounded-lg hover:bg-red-700 transition shadow-md"
        >
          Try Again
        </button>

        <button
          onClick={() => navigate('/')}
          className="w-full sm:w-auto bg-white border border-red-600 text-red-700 px-5 py-3 rounded-lg hover:bg-red-50 transition shadow-md"
        >
          Go to Homepage
        </button>

      </div>

      <div className="mt-10 text-sm text-gray-400 text-center">
        Need help? Contact <span className="font-semibold text-red-600">BookTrip4Me</span> support 💬
      </div>
    </div>
  );
};

export default PaymentFailure;
